<template>
    <v-row v-show="[1,4,5,8].includes(userRole)">
        <v-col cols="12">
            <v-card>
                <v-card-title>
                    Día
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4">
                            <v-card class="mx-auto" color="blue">
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title class="headline white--text">Clientes</v-list-item-title>
                                        <v-list-item-subtitle class="white--text">Clientes registrados</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-card-text>
                                    <v-row align="center">
                                        <v-col class="display-3 white--text" cols="12">
                                            <v-icon left class="white--text">mdi-account</v-icon> {{clientesDiaValue}}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="4">
                            <v-card class="mx-auto" color="blue">
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title class="headline white--text">Pedidos</v-list-item-title>
                                        <v-list-item-subtitle class="white--text">Pedidos finalizados</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-card-text>
                                    <v-row align="center">
                                        <v-col class="display-3 white--text" cols="12">
                                            <v-icon left class="white--text">mdi-cart</v-icon>{{pedidosDiaValue}}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="4">
                            <v-card class="mx-auto" color="blue">
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title class="headline white--text">Ventas</v-list-item-title>
                                        <v-list-item-subtitle class="white--text">Venta total del día</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-card-text>
                                    <v-row align="center">
                                        <v-col class="display-3 white--text" cols="12">
                                            <v-icon left class="white--text">mdi-currency-usd</v-icon> {{ventasDiaValue}}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-card-title>Pedidos</v-card-title>
                                <v-card-text>
                                    <canvas id="chartEstatusesDia" height="50px"></canvas>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-card>
                <v-card-title>Ventas</v-card-title>
                <v-card-text>
                    <canvas id="chartVentasPorDia" height="50px"></canvas>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-card>
                <v-card-title>Pedidos</v-card-title>
                <v-card-text>
                    <canvas id="chartPedidosPorDia" height="50px"></canvas>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-card>
                <v-card-title>Clientes</v-card-title>
                <v-card-text>
                    <canvas id="chartClientesPorDia" height="50px"></canvas>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import axios from 'axios'
    import Chart from 'chart.js'
    export default {
        data: () => ({
            pedidosDiaValue: 0,
            clientesDiaValue: 0,
            ventasDiaValue: 0,
            pedidosEstatuses: []
        }),
        mounted() {
            this.loadStats()
        },
        computed : {
            userRole(){
                return this.$root.user ? this.$root.user.role : 0;
            },
        },
        methods: {
            loadStats() {
                axios.get('/api/stats/mes-dia').then(response => {
                    this.drawLineChart('chartVentasPorDia', response.data.data.map(data => {
                        data.value = data.pedidos_total
                        return data
                    }), true, true)
                    this.drawLineChart('chartPedidosPorDia', response.data.data.map(data => {
                        data.value = data.pedidos_count
                        return data
                    }), true)
                    this.drawLineChart('chartClientesPorDia', response.data.data.map(data => {
                        data.value = data.clientes_count
                        return data
                    }), true)
                })
                axios.get('/api/stats/dia-pedidos-por-estatus').then(response => {
                    this.drawLineChart('chartEstatusesDia', response.data.data.map(data => {
                        return {
                            label: data.nombre,
                            value: data.pedidos_count
                        }
                    }))
                })
                axios.get('/api/stats/dia').then(response => {
                    this.pedidosDiaValue = response.data.data.pedidos_count
                    this.clientesDiaValue = response.data.data.clientes_count
                    this.ventasDiaValue = new Intl.NumberFormat("es-MX", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                    }).format(response.data.data.pedidos_total)
                })
            },
            drawLineChart(tagId, dataset, prefixTitle = false, currency = false) {
                let self = this;
                new Chart(document.getElementById(tagId), {
                    type: 'line',
                    data: {
                        labels: dataset.map(data => { return data.label }),
                        datasets: [{
                            data: dataset.map(data => { return data.value }),
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                            ],
                            borderColor: [
                                'rgba(255, 99, 132, 1)',
                            ],
                            borderWidth: 1
                        }]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                display: true
                            }],
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    callback: function (value) {
                                        return currency ? self.$options.filters.currency(value) : value;
                                    }
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    let prefix = (currency ? 'Monto: ' : 'Cantidad: ')
                                    let format = prefix + (data.datasets[tooltipItem.datasetIndex].label || '');
                                    if (currency) {
                                        format += self.$options.filters.currency(tooltipItem.yLabel);
                                    } else {
                                        format += tooltipItem.yLabel
                                    }

                                    return format;
                                },
                                title: function (tooltipItem) {
                                    let format = (prefixTitle ? 'Día ' : '') + tooltipItem[0].label;

                                    return format;
                                }
                            }
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
